<template>
  <v-sheet
    class="branch-footer-shadow wd-fixed wd-z-10 wd-w-screen wd-bottom-0 wd-px-5 wd-py-3 !wd-flex !wd-items-center !wd-justify-between wd-text-obase"
    height="64"
  >
    <div class="branch-info">
      <template v-if="!noRating">
        <h2 class="branch-name">{{ branch.name }}</h2>
        <div class="d-flex" @click="openCommentModal">
          <funnow-icon class="mr-1" max-width="20" :image-path="'star_orange.svg'" />
          <span class="comment-number-text"> {{ `${branch.rating} (${branch.number_of_comments})` }} </span>
        </div>
      </template>
      <template v-else>
        <h2 class="wd-w-full wd-mb-[2px] wd-text-obase wd-font-medium wd-truncate">{{ labelName }}</h2>
        <div class="wd-flex wd-text-obase">
          <span v-if="isSubHeadcountLabelShown" class="wd-text-orange50 wd-mr-2"> {{ $t('all_number_pax', [headCount]) }} </span>
          <template v-if="!isCrossDay">
            <span v-if="!startTime" class="wd-text-gray60"> {{ $t('select_time_empty') }} </span>
            <span v-else class="wd-text-orange50"> {{ labelTime }} </span>
          </template>
        </div>
      </template>
    </div>
    <v-btn v-scroll-to="{ el: '#main-booking-card', offset: -130 }" class="booking__btn ml-5 text-white elevation-0" color="orange50" height="40">
      {{ $t('booking_button') }}
    </v-btn>
  </v-sheet>
</template>

<script>
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import { useBranchBookingFlags } from '@/composition/useBranchBooking'

export default defineComponent({
  name: 'BranchBookingFooter',
  components: {
    FunnowIcon,
  },
  props: {
    branch: { type: Object, default: () => ({}) },
    productName: { type: String, default: '' },
    headCount: { type: Number, default: 0 },
    startTime: { type: String, default: '' },
    endTime: { type: String, default: '' },
    noRating: { type: Boolean, default: false },
    isCrossDay: { type: Boolean, default: false },
  },
  setup(props) {
    const nuxtApp = useNuxtApp()
    const branch = computed(() => props.branch)
    const { isHeadcountFirst } = useBranchBookingFlags(branch)

    const productLabel = computed(() => props.productName || nuxtApp.$i18n.t('select_product_empty'))
    const headcountLabel = computed(() =>
      props.headCount ? nuxtApp.$i18n.t('all_number_pax', [props.headCount]) : nuxtApp.$i18n.t('limitation_non_selected')
    )
    const labelName = computed(() => (isHeadcountFirst.value ? headcountLabel.value : productLabel.value))

    const labelTime = computed(() => {
      const startTime = props.startTime && nuxtApp.$dayjs(props.startTime).format('YYYY/MM/DD HH:mm')
      const endTime = props.endTime && nuxtApp.$dayjs(props.endTime).format('YYYY/MM/DD HH:mm')
      if (startTime && endTime) {
        return `${startTime} ~ ${endTime}`
      }
      return startTime || props.startTime
    })

    const isSubHeadcountLabelShown = computed(() => (isHeadcountFirst.value ? false : !!props.headCount))

    function openCommentModal() {
      // TODO: open modal by data not by component function
    }

    return {
      labelName,
      labelTime,
      openCommentModal,
      isSubHeadcountLabelShown,
    }
  },
})
</script>

<style>
.branch-footer-shadow {
  box-shadow: 0 12px 48px 16px rgba(0, 0, 0, 0.06), 0 9px 28px 0 rgba(0, 0, 0, 0.1), 0 6px 16px -8px rgba(0, 0, 0, 0.16) !important;
}
</style>
